import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';

//Servicios
import { DefaultService } from '../../services/default.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  public login:boolean = false;
  public user:any = {};
  
  constructor(
    private http: HttpClient,
    public _defaultService: DefaultService,
  ) { 
  }

  ngOnInit() {
    this._defaultService.isLogged().subscribe(result => {
      if(result != null && result.emailVerified == true){
        this._defaultService.Data("users", result.uid).subscribe(user => {
          this.user = user;
          this.http.get<{ip:string}>('https://jsonip.com').subscribe( data => {
              if(this.user.ip != data.ip || this.user.ip == undefined){
                this._defaultService.signOut();
                alert("Hay otro inicio de sesión desde otro dispositivo. Vuelve a iniciar sesión o cambie la contraseña");
              }else{
                this.login = true;
              }
          });
        });
      } 
    });
  }

  openCheckout() {
    if(this.login){
      var handler = (<any>window).StripeCheckout.configure({
        key: 'pk_live_gIdvvDNs0RjGHU0DBzn4MNyP',
        locale: 'auto',
        token: (token: any) => { 
          this.pagar(token.id); 
        }
      });
  
      //this._defaultService.sdfsdf(this.user.uid, token, {precio: 1, fecha: Date.now(), concepto: "ienrique premium content"});

      handler.open({
        name: 'Premium',
        description: 'ienrique premium content',
        amount: 2500
      });
    }else{
      alert("Tienes que iniciar sesión para poder realizar el pago");
    }


  }

  pagar(token){
    console.log(token);
    this._defaultService.pay(this.user.uid, token, {precio: 25, fecha: Date.now(), concepto: "ienrique premium content"});
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts